var _desc, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-0.5 -0.5 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "Long-Arrow-Down-Right--Streamline-Iconoir",
    height: 16,
    width: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Long Arrow Down Right Streamline Icon: https://streamlinehq.com\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.878125 14.1609375 3.2156249999999997 -3.2156249999999997 -3.2156249999999997 -3.2156249999999997",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.09375 10.9453125h-5.5125c-2.029625 0 -3.675 -1.645375 -3.675 -3.675v-6.4312499999999995",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownRightArrow);
export default __webpack_public_path__ + "static/media/DownRightArrow.ecddaf41c11ff2bba90765ec2840d3a9.svg";
export { ForwardRef as ReactComponent };